import { useState, useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import api from '../../utils/api';
import '../../styles/Pages.css';

function GoverningCouncil() {
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/committee-members?committee=governing-council')
            .then(r => setMembers(r.data))
            .catch(() => setMembers([]))
            .finally(() => setLoading(false));
    }, []);

    const fallback = [
        { sr: 1, name: 'President, A.J.M.V.P. Samaj', designation: 'Chairman', category: 'Management Representative' },
        { sr: 2, name: 'Dr. Sahadeo Aher', designation: 'Principal', category: 'Ex-officio Member Secretary' },
        { sr: 3, name: 'UGC Nominee', designation: 'Professor', category: 'UGC Nominee' },
        { sr: 4, name: 'State Government Nominee', designation: 'Officer', category: 'Govt. Nominee' },
        { sr: 5, name: 'Savitribai Phule Pune University Nominee', designation: 'Professor', category: 'University Nominee' },
    ];

    const display = members.length ? members : fallback;

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Management › Governing Council</p>
                <h1>Governing Council</h1>
                <p>The apex body governing the college's academic and administrative policies.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>Council Members</h2>
                    {loading ? <p>Loading...</p> : (
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th>Sr.</th><th>Name</th><th>Designation</th><th>Category</th>
                                </tr>
                            </thead>
                            <tbody>
                                {display.map((m, i) => (
                                    <tr key={i}>
                                        <td>{m.sr || i + 1}</td>
                                        <td style={{ fontWeight: 600 }}>{m.name}</td>
                                        <td>{m.designation}</td>
                                        <td>{m.category || m.role || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className="info-card">
                    <h2>Role of Governing Council</h2>
                    <ul>
                        <li>Framing policies for the college's academic and financial functioning.</li>
                        <li>Approving the annual budget and audited accounts.</li>
                        <li>Making appointments of Principal and senior staff as per university and government norms.</li>
                        <li>Monitoring the implementation of policies and development programs.</li>
                        <li>Reviewing the annual reports submitted by the Principal.</li>
                    </ul>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default GoverningCouncil;
